import Radium from "radium";
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import SeoHelmets from '../SeoOptimazation/SeoHelmets';
import { useParams } from 'react-router-dom';
import userImage from "../../Image/user.png";
import Content from '../AllPageContent/AllPageContent';
import Buttontabs from '../Buttontabs/Buttontabs';
import CurrentAffair from '../CurrentAffair/CurrentAffair';
import { fetchblogdetail } from '../DynamicCourse/api';
import Likeshare from '../LikeandShareCompoent/Likeshare';
import Loader from '../Loader/Loader';
import CivilTopSection from '../ReusableComponent/CIVIL/CivilTopSection/CivilTopSection';
import "../ReusableComponent/CIVIL/CivilTopSection/CivilTopSection.css";

function Dynamicblog() {
    const { blogurl } = useParams();
    const [newData, setNewData] = useState(null);
    const [initialViewCount, setInitialViewCount] = useState(null);
    const Buttonname = "Singlebutton";
    const componentName = "Blog";
    const [contentToShow, setContentToShow] = useState('In News');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchblogdetail(blogurl);
                setNewData(data[0]);
                setInitialViewCount(data[0]?.ViewCount);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [blogurl]);
    if (!newData) {
        return <div style={{ backgroundColor: "white", zIndex: "180", width: "100%", height: "100vh", position: "fixed", top: "0" }}><Loader /></div>
    }
    const data = {
        academyName: newData.Title,
        userImage: userImage,
        userName: 'INSIGHT IAS',
        Image: newData.Image,
        like: (newData.LikeCount || 0) + (newData.PreLikes || 0),
        view: (newData.ViewCount || 0) + (newData.preViews || 0),

    };

    const paragraphs = newData.Description
    // const paragraphs = []
    const noteurl = newData.NotePDF

    const blogStyle = {
        before: {
            content: '""',
            width: "100%",
            backgroundImage: `url(${newData.Image})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "top",
            opacity: "0.5",
            position: "absolute",
            filter: "blur(50px)",
            zIndex: "1"
        }
    }
    const t1 = newData.MetaTitle
    const t2 = newData.MetaDescription
    const t3 = newData.Image

    return (
        <>
            <SeoHelmets 
                title={newData.MetaTitle || newData.Title} 
                description={newData.MetaDescription || newData.Description?.substring(0, 160)}
                image={newData.Image}
                url={window.location.href}
            />
            {/* Civil Cop Section Start */}
            <section className={`${blogurl} dynamic-blog`}>
                <section style={blogStyle.before} className='dynamic-blog-before' />
                {/* Civil Top Section Start */}
                <CivilTopSection
                    academyName1={data.academyName}
                    userImage={data.userImage}
                    userName={data.userName}
                    Image={data.Image}
                />
                {/* Civil Top Section End */}
            </section>
            <div className='Civil-section'>
                <div className='civil-row'>
                    <div className='col-lg-8 col-md-12 col-sm-12 me-2'>
                        <div className='BlogPage-box2 dynamicPage-box2 d-flex align-items-center flex-wrap justify-content-between'>
                            <div>
                                <Buttontabs componentName={componentName} setContentToShow={setContentToShow} />
                            </div>
                            <div>
                                <Likeshare Like={data.like} setNewData={setNewData} Sn={newData.Sn} url={blogurl} view={data.view} />
                            </div>
                        </div>
                        <Content paragraphs={paragraphs} />
                        {/* <ButtonPage Pagename={Buttonname} noteurl={noteurl} /> */}
                        {/* <Tag /> */}
                    </div>
                    {/* Civil right Section Start */}
                    <div className='col-lg-4 col-md-12 col-sm-12'>
                        <div className='card p-2'>
                            <CurrentAffair componentName={componentName} />
                        </div>
                    </div>
                    {/* Civil right Section End */}
                </div>
            </div>
            {/* Civil Cop Section End */}
        </>
    )
}

export default Radium(Dynamicblog);